const CustomerServiceEmail = () => (
  <a href="mailto:creative@marmosetmusic.com" target="_blank">
    creative@marmosetmusic.com
  </a>
)

export default CustomerServiceEmail
